const config = {
  apiUrl: process.env.REACT_APP_API_URL ?? 'https://api-prod.skillcraft.app',
  insiderBuild: true,
  alternativeGameFlow: true,
};

export default config;
